import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ValueProposition from './components/ValueProposition';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import TargetClients from './components/TargetClients';
import GallerySection from './components/GallerySection';
import ServiceAreaMap from './components/ServiceAreaMap';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import SeoJsonLd from '@/components/feature/SeoJsonLd';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-dark-base text-white overflow-x-hidden">
      <SeoJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <ValueProposition />
        <HowItWorks />
        <Pricing />
        <TargetClients />
        <GallerySection />
        <ServiceAreaMap />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default HomePage;
